import {createSelector} from 'reselect';
import {StoreState} from '@/app/store';

export const selectDomainConfig = (state: StoreState) => state.config.domain;
export const selectIsPreferencesReady = (state: StoreState) => state.config.preferencesReady;
export const selectPreferences = (state: StoreState) => state.config.preferences;

export const selectHasPersonalizedPreferences = (state: StoreState) => !!state.config.preferences.mainPageLocationMode;

export const selectLanguage = (state: StoreState) => state.config.preferences.lang;
export const selectTemperatureUnit = (state: StoreState) => state.config.preferences.temperatureUnit;
export const selectPressureUnit = (state: StoreState) => state.config.preferences.pressureUnit;
export const selectSpeedUnit = (state: StoreState) => state.config.preferences.speedUnit;
export const selectClockType = (state: StoreState) => state.config.preferences.clockType;

export const selectWeatherViewMode = (state: StoreState) => state.config.preferences.weatherViewMode;
export const selectWeatherViewHiddenFields = (state: StoreState) => state.config.preferences.weatherViewHiddenFields;

export const selectMainPageLocationMode = (state: StoreState) => state.config.preferences.mainPageLocationMode;
export const selectDefaultLocationId = (state: StoreState) => state.config.preferences.defaultLocationId;
export const selectDefaultLocationInfo = (state: StoreState) => state.config.preferences.defaultLocationInfo;

export const selectNoAds = (state: StoreState) => state.config.noAds;

export const selectMainPageLocation = createSelector(
	[selectMainPageLocationMode, selectDefaultLocationId, selectDefaultLocationInfo],
	(mainPageLocationMode, defaultLocationId, defaultLocationInfo) => {
		return {mainPageLocationMode, defaultLocationId, defaultLocationInfo};
	},
);
export const selectWeatherView = createSelector(
	[selectWeatherViewMode, selectWeatherViewHiddenFields],
	(viewMode, hiddenFields) => {
		return {viewMode, hiddenFields};
	},
);

export const selectUnitTypes = createSelector(
	[selectTemperatureUnit, selectPressureUnit, selectSpeedUnit, selectClockType],
	(temperatureUnit, pressureUnit, speedUnit, clockType) => {
		return {temperatureUnit, pressureUnit, speedUnit, clockType};
	},
);
